import { PulsingElephantLogomark } from "$components/elephant-logomark";
import { PALETTE } from "$global-providers/mui-provider/palette";
import { TYPOGRAPHY as typography } from "$global-providers/mui-provider/typography";
import { styled } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
}));
/**
 * Uses raw HTML elements and injects translations and styled components so that this page may be used at the
 * root of our app, outside of any contexts.
 */

export const LoadingLogo: FC<
  {
    translations?: { loadingTip?: string };
    logomark?: React.ReactNode;
  } & React.HTMLAttributes<HTMLDivElement>
> = ({
  logomark = <PulsingElephantLogomark />,
  translations = {
    loadingTip: (
      <FormattedMessage id="loading.tip" defaultMessage="Loading..." />
    ),
  },
  ...restProps
}) => (
  <Container role="progressbar" {...restProps}>
    {logomark}
    <h6
      style={{
        // Couldn't import this from the theme without causing a build error with fonts
        fontFamily: typography.fontFamily,
        ...typography.subtitle1,
        color: PALETTE.primary.main,
        marginBlock: 0,
        // Visual center
        marginLeft: 12,
      }}
    >
      {translations.loadingTip}
    </h6>
  </Container>
);
